import React from 'react';
import './DeleteGroupPopup.css';
import { DELETE_GROUP_POPUP_STRINGS as STRINGS } from '../../assets/constants/deleteGroupPopup';

const DeleteGroupPopup = ({ group, onCancel, onConfirm }) => {
  return (
    <div className="delete-popup-overlay">
      <div className="delete-popup-container">
        <div className="delete-popup-content">
          <p className="delete-popup-heading">
            {STRINGS.HEADING_PREFIX} <strong>{group?.name}</strong> team?
          </p>
          <p className="delete-popup-note">
            <strong>{STRINGS.NOTE_LABEL}</strong> {STRINGS.NOTE_TEXT}
          </p>
        </div>
        <div className="delete-popup-actions">
          <button className="cancel-btn" onClick={onCancel}>
            {STRINGS.CANCEL_BUTTON}
          </button>
          <button className="delete-btn" onClick={onConfirm}>
            {STRINGS.CONFIRM_BUTTON}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteGroupPopup;
